export default __webpack_public_path__ + "static/media/PRIM_oldInfo.51d714f4.md";